<div class="not-found-container">
    <nuc-empty-state-component
        imageUrl="assets/images/empty_states/search.svg"
        title="404"
        subtitle="Oh nee! The page you're looking for doesn't exist."></nuc-empty-state-component>
    <a class="green" routerLink="/">Home</a>
</div>
